import { makeAutoObservable, observable } from 'mobx'
import React from 'react'

import { TopTiers } from '../Types'

export class MobileToolbarStore {
  showDialog: boolean = false
  topTier: TopTiers = TopTiers.None
  appleBottom: number = 0
  keyboardCoversContent: boolean = false
  _onNewComment?: () => void
  constructor() {
    makeAutoObservable(this, {
      topTier: observable,
      showDialog: observable,
      appleBottom: observable,
    })
  }
  toggleTopTier = (targetTier: TopTiers) => {
    this.topTier = this.topTier === targetTier ? TopTiers.None : targetTier
    this.showDialog = false
  }
  closeTopTier = () => {
    this.topTier = TopTiers.None
    this.showDialog = false
  }
  toggleDialog = () => {
    if (this.topTier !== TopTiers.None) {
      this.showDialog = !this.showDialog
    }
  }
  openDialog = () => {
    if (this.topTier !== TopTiers.None) {
      this.showDialog = true
    }
  }
  closeDialog = () => {
    if (this.topTier !== TopTiers.None) {
      this.showDialog = false
    }
  }
  createComment = () => {
    this.topTier = TopTiers.Comments
    this.showDialog = false
    this._onNewComment?.()
  }
  setAppleBottom = (appleBottom: number) => {
    this.appleBottom = appleBottom
  }
  setKeyboardCoversContent = (keyboardCoversContent: boolean) => {
    this.keyboardCoversContent = keyboardCoversContent
  }
  onNewComment(fn: () => void) {
    this._onNewComment = fn
  }
}

export const MobileToolbarContext = React.createContext<MobileToolbarStore | null>(null)

export const MobileToolbarProvider = ({ children }: { children: React.ReactNode }) => {
  const store = React.useMemo(() => new MobileToolbarStore(), [])
  return <MobileToolbarContext.Provider value={store}>{children}</MobileToolbarContext.Provider>
}

export const useMobileToolbar = () => {
  const context = React.useContext(MobileToolbarContext)
  if (context == null) {
    throw new Error('useMobileToolbar must be within MobileToolbarContext')
  }

  return context
}
